import React, { Component } from 'react';
import Slider from 'react-animated-slider';
import '../../../node_modules/react-animated-slider/build/horizontal.css';
import './homestyles.css';
import './animations.css';

import logoImage from '../../assets/images/33_logo.png'

import content from './content'

class Home extends Component {
  render() {
    return (
        <Slider autoplay={3000} className="slider-wrapper">
			{content.map((item, index) => (
				<div
					key={index}
					className="slider-content"
					style={{ background: `url('${item.image}') no-repeat center center` }}
				>
					<div className="inner">
						<img className="content-logo"  width="120"  height="150" src={logoImage} alt="" />
						<h1 dangerouslySetInnerHTML={{ __html: item.title }} />
						{ item.description!== '' &&
							<p>{item.description}</p>
						}
					</div>
				</div>
			))}
		</Slider>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home/index.js